import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const MEDICATION_REGISTRATIONS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./medication-registrations.component').then(m => m.MedicationRegistrationsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'stable/:stableId/batches',
    loadComponent: () =>
      import('./medication-registration-batches/medication-registration-batches.component').then(m => m.MedicationRegistrationBatchesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'stable/:stableId/batch/:batchId',
    loadComponent: () =>
      import('./medication-registration-detail/medication-registration-detail.component').then(m => m.MedicationRegistrationDetailComponent),
    canActivate: [AuthGuard],
  }
];
